(() => {
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
      body.classList.toggle('menu-open', !open);
    });
  }

  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-media-target]').forEach((button) => {
    button.addEventListener('click', () => {
      const id = button.dataset.mediaTarget;
      document.querySelectorAll('.product-gallery__item').forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === id));
      document.querySelectorAll('.product-thumb').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
    });
  });

  document.querySelectorAll('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) - 1);
  }));
  document.querySelectorAll('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    input.value = Number(input.value || 1) + 1;
  }));

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const productInfo = select.closest('.product-info');
      const price = productInfo && productInfo.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });

  const toast = document.querySelector('[data-cart-toast]');
  const updateCartCount = (count) => document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });
  document.querySelectorAll('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (!submit || submit.disabled) return;
      const original = submit.innerHTML;
      submit.disabled = true;
      submit.textContent = 'Adding...';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add item');
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await cartResponse.json();
        updateCartCount(cart.item_count);
        if (toast) {
          toast.hidden = false;
          toast.classList.add('is-visible');
          window.setTimeout(() => { toast.classList.remove('is-visible'); toast.hidden = true; }, 3500);
        }
      } catch (error) {
        submit.textContent = 'Please try again';
        window.setTimeout(() => { submit.innerHTML = original; }, 2200);
      } finally {
        submit.disabled = false;
        if (submit.textContent === 'Adding...') submit.innerHTML = original;
      }
    });
  });

  document.querySelectorAll('[data-faq-list]').forEach((list) => {
    const search = list.closest('.faq-page') && list.closest('.faq-page').querySelector('[data-faq-search]');
    const items = Array.from(list.querySelectorAll('[data-faq-item]'));
    const categories = Array.from(list.querySelectorAll('[data-faq-category]'));
    const empty = list.querySelector('[data-faq-empty]');

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => { if (other !== item) other.open = false; });
      });
    });

    if (search) {
      search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        let visibleCount = 0;
        items.forEach((item) => {
          const match = !query || (item.dataset.faqText || '').includes(query);
          item.hidden = !match;
          if (match) visibleCount += 1;
        });
        categories.forEach((heading) => {
          let node = heading.nextElementSibling;
          let hasVisible = false;
          while (node && !node.matches('[data-faq-category]')) {
            if (node.matches('[data-faq-item]') && !node.hidden) hasVisible = true;
            node = node.nextElementSibling;
          }
          heading.hidden = !hasVisible;
        });
        if (empty) empty.hidden = visibleCount !== 0;
      });
    }
  });

})();
